import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <section className="contact-page">

      {/* Hero Section */}
      <div className="contact-hero">
        <span>GET IN TOUCH</span>
        <h1>Contact Us</h1>
        <p>
          We'd love to hear from you. Reach out to us for product inquiries,
          showroom visits, partnerships, or any assistance you may need.
        </p>
      </div>

      {/* Main Section */}
      <div className="contact-container">

        {/* Left Side */}
        <div className="contact-info">
          <h2>Showroom Address</h2>

          <div className="info-box">
            <h4>📍 Address</h4>
            <p>IHDP Business Park</p>
            <p>Level 1, Plot No. 7</p>
            <p>Sector 127, Expressway</p>
            <p>Noida 201301</p>
            <p>Uttar Pradesh</p>
          </div>

          <div className="info-box">
            <h4>📞 Call Us</h4>
            <p>+91 7351847736</p>
            <p>+91 9810104567</p>
          </div>

          <div className="info-box">
            <h4>📧 Email</h4>
            <p>sr.merchandiser@inliving.com</p>
          </div>

          <div className="info-box">
            <h4>🕒 Working Hours</h4>
            <p>Monday - Saturday</p>
            <p>09:00 AM - 06:00 PM</p>
          </div>
        </div>

        {/* Right Side Form */}
        <div className="contact-form-wrapper">
          <h2>Send Us a Message</h2>

          <form className="contact-form">
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Email Address" />
            <input type="text" placeholder="Phone Number" />
            <input type="text" placeholder="Subject" />

            <textarea
              rows="6"
              placeholder="Write your message..."
            ></textarea>

            <button type="submit">
              Send Message
            </button>
          </form>
        </div>

      </div>

      {/* Map Section */}
      <div className="map-section">
        <iframe
          title="Noida Location"
          src="https://maps.google.com/maps?q=Sector%20127%20Noida&t=&z=13&ie=UTF8&iwloc=&output=embed"
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>

    </section>
  );
};

export default Contact;